import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/resume/components/ResumeInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
